/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(entityCategoryId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllOfficerLookups: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllOfficerLookupsResponse.Lookups.DP_LU_OfficerDirectorStatus',
      'GetAllOfficerLookupsResponse.Lookups.DP_LU_OfficerType'
    ],
    blueprint: {
      officerDirectorStatus: [
        '$..DP_LU_OfficerDirectorStatus',
        {
          id: '$..ID',
          status: '$..Status'
        }
      ],
      officerType: [
        '$..DP_LU_OfficerType',
        {
          id: '$..ID',
          type: '$..Type',
          categoryId: '$..CategoryId'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      response.officerType = _.filter(response.officerType, function(type) {
        return type.categoryId === entityCategoryId;
      });

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
